"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _set2 = _interopRequireDefault(require("lodash/set"));

var _api = require("@lce/api");

var _slice = require("@lce/slice");

var _i18n = require("@lce/i18n");

var _types = require("@lce/types");

var _analytics = require("@lce/analytics");

var _useCart = _interopRequireDefault(require("../../../useCart/useCart"));

var Styled = _interopRequireWildcard(require("./CartItem.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

/* eslint-disable react/forbid-component-props */
// eslint-disable-next-line max-lines-per-function
var CartItem = function CartItem(_a) {
  var item = _a.item;

  var _b;

  var _c = (0, _i18n.useTranslation)(),
      t = _c.t,
      language = _c.i18n.language;

  var _d = (0, _useCart["default"])(),
      remove = _d.remove,
      setQuantity = _d.setQuantity;

  var settings = (0, _api.useSettings)().data;

  var _e = (0, _api.useOrder)(),
      order = _e.order,
      type = _e.type;

  var locale = language;
  var showCalorieInfo = (_b = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _b === void 0 ? void 0 : _b.SHOW_CALORIE_INFO;

  var callUpdateEvent = function callUpdateEvent() {
    if (type === _types.Const.DELIVERY && (order === null || order === void 0 ? void 0 : order.storeId) && (order === null || order === void 0 ? void 0 : order.futureOrderTime)) {
      _analytics.GoogleEvents.futureOrderDeliveryCartUpdated({
        locationNumber: order.locationNumber
      });
    }
  };

  var currencyFormatter = (0, _i18n.getCurrencyFormatter)(locale, t);

  var handleSetQuantity = function handleSetQuantity(e) {
    e.persist();
    var re = /^[0-9\b]+$/;
    var quantity = e.target.value;

    if (quantity === '' || re.test(quantity)) {
      callUpdateEvent();
      var updateItem = item.customTicketId ? item.customTicketId : item.menuItemCode;
      setQuantity(updateItem, quantity);
    }
  };

  var removeItem = function removeItem() {
    callUpdateEvent();
    item.customTicketId ? remove(item.customTicketId) : remove(item.menuItemCode);
  };

  var handleQuantityOnBLur = function handleQuantityOnBLur(e) {
    e.target.value === '' && handleSetQuantity((0, _set2["default"])(e, 'target.value', 0));
  };

  var caloriesText = item.itemCaloriesText;
  var checkoutCalories = item.calories;
  var calories = caloriesText ? caloriesText : checkoutCalories;
  return React.createElement(Styled.CartItem, {
    "data-testid": "mini-cart__item-" + item.menuItemCode,
    flexDirection: "column",
    width: "1"
  }, React.createElement(_slice.Flex, {
    flexDirection: "row"
  }, React.createElement(_slice.Box, {
    flex: "1 1 auto",
    mr: 4
  }, React.createElement(_slice.Box, null, item.itemName && React.createElement(Styled.Name, {
    "data-testid": "mini-cart__item-itemName-" + item.menuItemCode
  }, item.itemName), showCalorieInfo && calories && React.createElement(_slice.Text, {
    "data-testid": "mini-cart__item-calories-" + item.menuItemCode
  }, calories)), item.customTicketId && React.createElement(_slice.Box, null, React.createElement(Styled.Toppings, {
    dangerouslySetInnerHTML: {
      __html: item.itemDescription
    }
  })), React.createElement(_slice.Flex, null, React.createElement(_slice.Box, {
    mr: 5
  }, React.createElement(Styled.Action, {
    as: "button",
    "data-testid": "mini-cart__remove-" + item.menuItemCode + "-from-cart",
    onClick: removeItem
  }, t('Common.Remove'))))), React.createElement(_slice.Box, {
    style: {
      textAlign: 'center'
    }
  }, React.createElement(_slice.Box, {
    mb: 2
  }, React.createElement(Styled.Price, {
    "data-testid": "mini-cart__item-price-" + item.menuItemCode
  }, currencyFormatter.format(item.price))), React.createElement(_slice.Flex, {
    alignItems: "center"
  }, React.createElement(Styled.QuantityLabel, {
    htmlFor: item.menuItemCode,
    mr: 2
  }, t('Header.Cart.Quantity Abbreviation')), React.createElement(_slice.Box, {
    width: "60px"
  }, React.createElement(Styled.Quantity, {
    "data-testid": "mini-cart__quantitySelector-" + item.menuItemCode,
    id: item.menuItemCode,
    onBlur: handleQuantityOnBLur,
    onChange: handleSetQuantity,
    value: item.quantity
  }))))));
};

var _default = CartItem;
exports["default"] = _default;